export default {
  inject: ["$formVars"],
  computed: {
    formInput(this: { $formVars: any }) {
      return this.$formVars().input;
    },
    formErrors(this: { $formVars: any }) {
      return this.$formVars().errors;
    },
    formPhase(this: { $formVars: any }) {
      return this.$formVars().phase;
    },
    formIsLoading(this: { $formVars: any }) {
      return this.$formVars().isLoading;
    }
  },
  methods: {
    hasFormError(path: string) {
      return (this as any).$formVars().hasError(path);
    }
  }
};
